import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './Hero.scss';

const slides = [
  { desktop: '/images/index/bg01.png', mobile: '/images/index/m_bg01.png' },
  { desktop: '/images/index/bg02.png', mobile: '/images/index/m_bg02.png' },
  { desktop: '/images/index/bg03.png', mobile: '/images/index/m_bg03.png' },
];

const Hero = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 1180);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <section className="hero">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation={!isMobile ? {
          prevEl: '.hero__nav--prev',
          nextEl: '.hero__nav--next',
        } : false}
        pagination={{ 
          clickable: true,
          el: '.hero__indicators',
          bulletClass: 'hero__indicator',
          bulletActiveClass: 'hero__indicator--active'
        }}
        autoplay={{
          delay: 8000,
          disableOnInteraction: false,
        }}
        loop={true}
        speed={500}
        className="hero__swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index} className="hero__slide">
            <img
              src={isMobile ? slide.mobile : slide.desktop}
              alt={`슬라이드 ${index + 1}`}
              className="hero__image"
            />
          </SwiperSlide>
        ))}
        
        {/* 네비게이션 버튼 */}
        {!isMobile && (
          <>
            <div className="hero__nav hero__nav--prev">&#8249;</div>
            <div className="hero__nav hero__nav--next">&#8250;</div>
          </>
        )}
        
        {/* 인디케이터 */}
        <div className="hero__indicators"></div>
      </Swiper>
    </section>
  );
};

export default Hero;